import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { TemplateResep } from "@/utils/templateResep";

export interface ObatDefaults {
  source: "personal" | "institusi" | "template" | "profil" | "sediaan" | "none";
  rute_id?: number | null;
  frekuensi_id?: number | null;
  ap_dosis?: string | null;
  ap_tambahan?: string | null;
  qty?: number | null;
  qty_unit?: string | null;
  dosis_qty?: number | null;
  satuan_dosis_id?: number | null;
  aturan_tambahan_ids?: number[];
  sediaan_group?: string | null;
  durasi_hari?: number | null;
  is_high_alert?: boolean;
  is_lasa?: boolean;
  is_obat_kronis?: boolean;
  resep_max_value?: number | null;
  restriksi?: string | null;
  sumber?: Record<string, string>;
}

export type Regimen = TemplateResep;

async function obatDefaults(obatId: string): Promise<ObatDefaults> {
  const response = await http
    .getData(`/resep-ralan-unified/obat/${encodeURIComponent(obatId)}/defaults`)
    .catch(err => {
      // Defaults are best-effort: don't alert on miss.
      return Promise.reject(err);
    });

  return response.data as ObatDefaults;
}

async function simpanTemplate(payload: {
  nama: string;
  text: string;
  items: any[];
  racikan: any[];
}): Promise<TemplateResep> {
  const response = await http
    .postData(`/template/resep-obat`, payload)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data.data as TemplateResep;
}

async function regimenFast(params: {
  q?: string;
  scope?: "personal" | "all";
}): Promise<Regimen[]> {
  const response = await http
    .getDataParam(`/resep-ralan-unified/regimen-fast`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data.data as Regimen[];
}

export default {
  obatDefaults,
  regimenFast,
  simpanTemplate
};
